
<template>
    
        <mars-view v-if="menus" :class="['law-contents-container', isSwan ? 'swan-directory-container' : 'h5-directory-container']" @click.native="close"><mars-view class="main-content-box"><mars-view class="contents-title">目录</mars-view><mars-scroll-view class="contents-box" scroll-y><mars-view v-for="(firstLevelItem, firstLevelindex) in menus" :key="firstLevelItem.index"><mars-view class="first_level_title" @click.native.stop="clickContents(firstLevelItem.children, firstLevelindex, '', firstLevelItem.index)">
                    {{ firstLevelItem.text }}
                </mars-view><mars-view v-if="firstLevelItem.isShowChildren && firstLevelItem.children && firstLevelItem.children.length" class="second-menu-box"><mars-view v-for="(secondLevelItem, secondLevelindex) in firstLevelItem.children" :key="secondLevelItem.index"><mars-view :class="['second_level_title', secondLevelItem.isShowChildren ? 'medium' : '']" @click.native.stop="clickContents(secondLevelItem.children, firstLevelindex, secondLevelindex, secondLevelItem.index)">
                            {{ secondLevelItem.text }}
                        </mars-view><template v-if="secondLevelItem.isShowChildren && secondLevelItem.children && secondLevelItem.children.length"><mars-view v-for="thirdLevelItem in secondLevelItem.children" :key="thirdLevelItem.index" class="third_level_title" @click.native.stop="clickContents([], '', '', thirdLevelItem.index)">
                                {{ thirdLevelItem.text }}
                            </mars-view></template></mars-view></mars-view></mars-view></mars-scroll-view></mars-view></mars-view>
    
</template>

<script>
export default {
  props: {
    menus: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      isSwan: "h5" === 'swan'
    };
  },
  methods: {
    close() {
      this.$emit('closeContents');
    },
    /**
     * 目录点击
     * @param {array} children 子节点
     * @param {number} firstIndex 一级节点
     * @param {number} secondIndex 二级节点
     * @param {number} jumpId 跳转id
     */

    clickContents(children, firstIndex, secondIndex, jumpId) {
      if (Array.isArray(children) && children.length) {
        this.$emit('changeContentsStatus', {
          firstIdx: firstIndex,
          secondIdx: secondIndex
        });
      } else {
        this.$emit('jumpContent', {
          jumpId
        });
      }
    }
  }
};
</script>

<style scoped>
.law-contents-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 1000001;
}
.law-contents-container.swan-directory-container {
  height: 100vh;
}
.law-contents-container .main-content-box {
  float: right;
  width: 80.19vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  box-sizing: border-box;
}
.law-contents-container .main-content-box .contents-title {
  padding: 29.63vw 0 5.56vw 3.38vw;
  font-family: PingFang SC;
  font-size: 6.52vw;
  color: #1e1f24;
  line-height: 6.52vw;
  font-weight: 700;
}
.law-contents-container .main-content-box .contents-box {
  height: 0;
  flex: 1;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 2.66vw 4.83vw;
}
.law-contents-container .main-content-box .contents-box .first_level_title {
  margin-top: 4.11vw;
  height: 11.03vw;
  line-height: 11.03vw;
  font-family: PingFang SC;
  padding-left: 4.11vw;
  font-size: 4.11vw;
  color: #1e1f24;
  background: #f5f6f9;
  border-radius: 1.37vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.law-contents-container .main-content-box .contents-box .second-menu-box {
  padding: 0.89vw 0 1.53vw;
}
.law-contents-container .main-content-box .contents-box .second_level_title,
.law-contents-container .main-content-box .contents-box .third_level_title {
  padding: 4.51vw 2.58vw 0 5.48vw;
  font-family: PingFang SC;
  font-size: 3.62vw;
  color: #1e1f24;
  line-height: 4.43vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.law-contents-container .main-content-box .contents-box .third_level_title {
  padding: 4.51vw 2.58vw 0 10.95vw;
}

</style>
